import React from 'react';

export default function DurationOverride({ value, defaultValue, onChange, error }) {
  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: '13px',
        fontWeight: '600',
        color: '#2b2b2b',
        marginBottom: '6px'
      }}>
        Duration (work days)
      </label>

      <input
        type="number"
        min="1"
        max="30"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value) || 1)}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: error ? '1px solid #dc2626' : '1px solid #ddd',
          borderRadius: '8px',
          fontSize: '14px',
          outline: 'none'
        }}
        onFocus={(e) => {
          if (!error) e.target.style.borderColor = '#8B4513';
        }}
        onBlur={(e) => {
          if (!error) e.target.style.borderColor = '#ddd';
        }}
      />

      {error && (
        <div style={{
          fontSize: '12px',
          color: '#dc2626',
          marginTop: '4px'
        }}>
          {error}
        </div>
      )}

      <div style={{
        fontSize: '11px',
        color: '#999',
        marginTop: '4px'
      }}>
        Default: {defaultValue} day{defaultValue !== 1 ? 's' : ''} • Weekends and holidays skipped
      </div>
    </div>
  );
}